module.exports = __webpack_public_path__ + "img/safewater-full.55c906ab.png";